// import jwtDecode from "jwt-decode";
export const LOCAL_STORAGE_JWT_ACCESS_TOKEN = "access_token";
export const LOCAL_STORAGE_JWT_REFRESH_TOKEN = "refresh_token";
export const STORAGE_EXP = "exp";
export const STORAGE_TOKEN_EXP = "token_exp";

export const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (err) {
    console.error("Invalid token", err);
    return null;
  }
};

export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  return decoded.exp <= Math.floor(Date.now() / 1000);
};

export const getAccessToken = () => {
  return localStorage.getItem("access_token");
};

export const getCookie = (name) => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
};

export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token");
};

export const setJWTTokens = (data) => {
  const jwtAccessToken = data.access;
  const jwtRefreshToken = data.refresh;
  if (jwtRefreshToken) {
    localStorage.setItem(LOCAL_STORAGE_JWT_REFRESH_TOKEN, jwtRefreshToken);
  }

  localStorage.setItem(LOCAL_STORAGE_JWT_ACCESS_TOKEN, jwtAccessToken);
  const decodedToken = decodeToken(jwtAccessToken);
  if (decodedToken) {
    Object.keys(decodedToken).forEach((key) =>
      localStorage.setItem(key, decodedToken[key])
    );
    
    const jwtExpiryTime = decodedToken["exp"];
    if (jwtExpiryTime) {
      const tokenExpirationTimeInSeconds =
        jwtExpiryTime - Math.floor(Date.now() / 1000);
      localStorage.setItem(STORAGE_TOKEN_EXP, tokenExpirationTimeInSeconds);
    }
  }
};

export const clearAuthCookies = () => {
  // Expire the backend-set auth cookies. App.js re-seeds these into localStorage,
  // so leaving an expired accessJWT/refreshJWT cookie behind caused the /login
  // redirect loop (stale token re-seeded -> refresh fails -> redirect -> repeat).
  const expire = "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  document.cookie = "accessJWT" + expire;
  document.cookie = "refreshJWT" + expire;
};

export const clearJWTTokens = () => {
  localStorage.removeItem(LOCAL_STORAGE_JWT_ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_JWT_REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_TOKEN_EXP);
  localStorage.removeItem("id");
  localStorage.removeItem("profile");
  localStorage.removeItem("name");
  localStorage.removeItem("email");
  localStorage.removeItem("user_type");
  localStorage.removeItem("domain");
  localStorage.removeItem("lang");
  localStorage.removeItem("pix_agent");
  clearAuthCookies();
};

export const getTokenExp = () => {
  return localStorage.getItem(STORAGE_TOKEN_EXP);
};
